import { hasOneOf, hasOneOfZero } from '../util'
export default {
  methods: {
    _vehiclefilter (col, queryArr) {
      let value = [...this.value]
      console.log(value)
      this.insideTableData = value.filter(item => hasOneOf(item.registrationNum, queryArr))
      this._tableResize()
    },
    _filter (col, queryArr) {
      let value = [...this.value]
      console.log(value)
      // 要按哪一列筛选的列号
      // this.insideTableData = value.filter(item => hasOneOf(item[col], queryArr));
      // 更改为按车辆状态搜索 @jlliang
      this.insideTableData = value.filter(item => hasOneOf(item.terminalState, queryArr))
      this._tableResize()
    },
    _cancelFilter () {
      this.insideTableData = [...this.value]
      this._tableResize()
    },
    _filterZero (col) {
      let value = [...this.value]
      this.insideTableData = value.filter(item => hasOneOfZero(item.alarm))
      this._tableResize()
    }
  }
}
